function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);













class CartItems extends HTMLElement {
  constructor() {
    super();




    

    document.getElementById('empty-cart-link')?.addEventListener('click', function (e) {
      e.preventDefault();
  
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(() => {
        window.location.reload(); // reloads the current page after cart is cleared
      })
      .catch(error => console.error('Error emptying cart:', error));
    });



// START OF CUSTOM CART NOTE LOGIC

/**
 * This JavaScript ensures customers fill out the cart note before proceeding to checkout.
 * 
 * If the cart note contains fewer than 5 characters, an overlay is placed on top of the 
 * checkout button to prevent the customer from clicking it.
 * 
 * Previously, we attempted to disable the button directly, but the Easify Product Options App 
 * was overriding our JavaScript. Since we couldn't reliably re-target the checkout button, 
 * we implemented this workaround using an overlay div positioned above the button.
 * 
 * The cool part about this approach is that we don’t need to create any additional Liquid code 
 * to disable or enable the checkout button when the cart note is not filled out. If a collection has the 
 * metafield 'Fundraiser', the cart note is automatically rendered — and this JavaScript handles the logic 
 * no matter which collection it is.
 */


            // DOM Elements
            this.textarea = document.getElementById('Cart-note');
            this.checkoutButton = document.getElementById('CartDrawer-Checkout') || document.getElementById('checkout');
            this.reminderText = document.getElementById('reminder-text');
            this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

            this.checkoutBtnOverlay = document.getElementById('checkout-btn-overlay');
            // Initialize item count and debounce handler
            this.currentItemCount = this.calculateItemCount();
            this.debouncedOnChange = debounce((event) => this.onChange(event), 0);

            // Event Listeners
            this.addEventListener('change', this.debouncedOnChange);
            
            // Textarea Validation Logic
            if (this.textarea && this.checkoutButton && this.reminderText) {
              this.initTextareaValidation();
            }
          }

          // Initialize the textarea validation (CART-DRAWER)
          initTextareaValidation() {
            const validateTextarea = () => {
              const inputValue = this.textarea.value.trim();
              const isInvalid = inputValue.length < 5;
              // this.checkoutButton.disabled = isInvalid;

              if (isInvalid) {
                this.reminderText.textContent = 'Please fill out required field before continuing.';
                this.reminderText.style.color = '#e31111';
                this.reminderText.style.fontSize = '13px';
                this.reminderText.style.lineHeight = '15px';
                this.reminderText.style.textAlign = 'center';
                this.reminderText.style.display = 'block';
                this.reminderText.style.maxWidth = '396px';
                this.reminderText.style.margin = 'auto';
                this.reminderText.style.fontFamily = 'helvetica';
                // Shows the overlay
                this.checkoutBtnOverlay.style.display = 'block'
              } else {
                this.reminderText.style.display = 'none';
                // Hides the overlay
                this.checkoutBtnOverlay.style.display = 'none'
              }
            };

            // Debounced input listener for the textarea
            let debounceTimer;
            this.textarea.addEventListener('input', () => {
              clearTimeout(debounceTimer);
              debounceTimer = setTimeout(validateTextarea, 300);
            });

            // Initial validation
            validateTextarea();
          }


// END OF CUSTOM CART NOTE LOGIC















  // Calculate the total item count
  calculateItemCount() {
    return Array.from(this.querySelectorAll('[name="updates[]"]')).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
  }

  // Handle quantity change
  onChange(event) {
    console.log('Updating quantity...');
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
      
    );










  }

  // Get sections that need to be re-rendered
  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  // Update the quantity of items in the cart
  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
      .then((response) => response.text())
      .then((state) => this.handleCartState(state, line, name))
      .catch(() => this.handleError());
  }

  // Handle the updated cart state after a successful fetch
  handleCartState(state, line, name) {
    const parsedState = JSON.parse(state);
    this.classList.toggle('is-empty', parsedState.item_count === 0);
    
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
      if (elementToReplace) {
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }
    });








    

    this.updateLiveRegions(line, parsedState.item_count);

    // Focus handling after update
    const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
      cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
    } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
    } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
    }

    this.disableLoading();
  }

  // Handle errors during the cart update
  handleError() {
    this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (errors) errors.textContent = window.cartStrings.error;
    this.disableLoading();
  }

  // Update live regions to announce cart status
  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      if (lineItemError && quantityElement) {
        lineItemError.querySelector('.cart-item__error-text').innerHTML = window.cartStrings.quantityError.replace('[quantity]', quantityElement.value);
      }
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);
      setTimeout(() => cartStatus.setAttribute('aria-hidden', true), 1000);
    }
  }

  // Extract inner HTML from the fetched state for a specific section
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || '';
  }

  // Enable loading state
  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  // Disable loading state
  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

// Define the custom element
customElements.define('cart-items', CartItems);

// Cart Note Component
if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body });
      }, 100));
    }
  });
}






















